export default "__VITE_ASSET__6qBiuzzb__"